import type { PaymentCardBrand } from '@frontend/api-client';
import { resolvePaymentCardBrand } from '@frontend/api-client';
import { Visa } from '@frontend/assets';
import { Card, Icon, Image, LinkButton, Text, XStack, YStack } from '@frontend/web-react';

export type CreditCardProps = {
  brand: PaymentCardBrand;
  expiryDate: string;
  isDefault: boolean;
  isDeleteCardLoading: boolean;
  isMakeDefaultLoading: boolean;
  lastFourDigits: string;
  onDelete: () => void;
  onEditCard: () => void;
  onMakeDefault: () => void;
};

export const CreditCard = ({
  brand,
  expiryDate,
  isDefault,
  isDeleteCardLoading,
  isMakeDefaultLoading,
  lastFourDigits,
  onDelete,
  onEditCard,
  onMakeDefault,
}: CreditCardProps) => (
  <Card className="bg-trueWhite border-1 border-borderPrimary rounded-lg">
    <XStack className="gap-sm items-center">
      {/* eslint-disable-next-line tailwindcss/no-arbitrary-value */}
      <YStack className="h-[18px] w-[27px]">
        <Image source={resolvePaymentCardBrand(brand, { fallback: Visa })} />
      </YStack>
      <XStack className="gap-md items-center">
        <Text type="h6">
          {brand.charAt(0).toUpperCase() + brand.slice(1)} {lastFourDigits}
        </Text>
        <Text color="tertiary" type="p-sm">
          {expiryDate}
        </Text>
        {isDefault ? (
          <Text className="p-xs bg-surfacePrimary rounded-sm" type="caption">
            Default
          </Text>
        ) : null}
      </XStack>
    </XStack>
    <XStack className="gap-lg w-full justify-end">
      {isDefault ? (
        <LinkButton
          label="Edit default card"
          leftIconName="IconPencil"
          leftIconProps={{ size: 'md' }}
          onClick={onEditCard}
          type="h6"
        />
      ) : (
        <XStack className="gap-lg">
          <LinkButton
            isLoading={isMakeDefaultLoading}
            label="Make this card default"
            leftIconName="IconCheck"
            leftIconProps={{ size: 'md' }}
            onClick={onMakeDefault}
            type="h6"
          />
          <Icon color="danger" isLoading={isDeleteCardLoading} name="IconTrash" onClick={onDelete} size="md" />
        </XStack>
      )}
    </XStack>
  </Card>
);
